import { render, staticRenderFns } from "./application_form.vue?vue&type=template&id=52f0f789&"
import script from "./application_form.vue?vue&type=script&lang=js&"
export * from "./application_form.vue?vue&type=script&lang=js&"
import style0 from "./application_form.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCheckbox,VForm,VTextField,VTextarea})


/* hot reload */
if (module.hot) {
  var api = require("/home/eu/public_ru/local/templates/international/int_site/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52f0f789')) {
      api.createRecord('52f0f789', component.options)
    } else {
      api.reload('52f0f789', component.options)
    }
    module.hot.accept("./application_form.vue?vue&type=template&id=52f0f789&", function () {
      api.rerender('52f0f789', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/main/application_form.vue"
export default component.exports